import { useEffect, useState, useRef } from "react";
import {
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  ListSubheader,
  Switch,
  FormControlLabel,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import {
  addSession,
  updateSession
} from "../../redux/actions";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import DialogActions from '@mui/material/DialogActions';
import { Link } from "react-router-dom";
import { getFullName } from "../../common/utils/datatable";
import "./SessionCreation.css";
import moment from "moment";
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { toastOptions } from '../../common/utils/toasterOptions';
// import CustomDatePicker from "./CustomeDatePicker";


const STATUS_OPTIONS = [
  { value: 'Published', label: 'Published' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Draft', label: 'Draft' },
];

const MenuProps = {
  PaperProps: {
    style: {  
      maxHeight: "30rem",
      width: "10rem",
    },
  },
};

export const SessionUpdate = (props) => {
  const {sessionDetails} = useSelector(({ MODULES }) => MODULES);
  const index = sessionDetails.data.findIndex(item => item.sessionId === props.sessionId);
  const sessionData = sessionDetails.data[index];
  
  // Debug: Log the session data to see the actual structure
  console.log('Session data for editing:', sessionData);
  console.log('Hosts array:', sessionData.hosts);
  console.log('Session start time:', sessionData.sessionStartTime);
  console.log('Session end time:', sessionData.sessionEndTime);
  
  const [sessionName, setSessionName] = useState(sessionData.sessionName);
  // Fix: Use sessionStartTime and sessionEndTime from API response and format properly for time input
  const [startTime, setStartTime] = useState(() => {
    if (sessionData.sessionStartTime) {
      try {
        // Handle different possible formats: "08/22/2025 15:43:00" or just time
        let timeString = '';
        if (sessionData.sessionStartTime.includes(' ')) {
          // Format: "08/22/2025 15:43:00"
          const timePart = sessionData.sessionStartTime.split(' ')[1];
          timeString = timePart.substring(0, 5); // Get HH:MM
        } else {
          // Direct time format
          timeString = sessionData.sessionStartTime.substring(0, 5);
        }
        console.log('Formatted start time:', timeString);
        return timeString;
      } catch (error) {
        console.error('Error parsing start time:', error);
        return '';
      }
    }
    return '';
  });
  const [endTime, setEndTime] = useState(() => {
    if (sessionData.sessionEndTime) {
      try {
        // Handle different possible formats: "08/22/2025 15:47:00" or just time
        let timeString = '';
        if (sessionData.sessionEndTime.includes(' ')) {
          // Format: "08/22/2025 15:47:00"
          const timePart = sessionData.sessionEndTime.split(' ')[1];
          timeString = timePart.substring(0, 5); // Get HH:MM
        } else {
          // Direct time format
          timeString = sessionData.sessionEndTime.substring(0, 5);
        }
        console.log('Formatted end time:', timeString);
        return timeString;
      } catch (error) {
        console.error('Error parsing end time:', error);
        return '';
      }
    }
    return '';
  });
  const [status, setStatus] = useState(sessionData.status);
  const [sessionDate, setSessionDate] = useState(sessionData.sessionDate);
  const [description, setDescription] = useState(sessionData.description);
  const [selectAll, setSelectAll] = useState(false);

  const { allUserDetails, userData } = useSelector(({ USER }) => USER);
  const { listItems } = useSelector(({ MODULES }) => MODULES);
  const [userMembers, setUserMembers] = useState(allUserDetails);
  const [userSkills, setUserSkills] = useState(listItems ? listItems.Skills : []);
  const [totalSeats, setTotalSeats] = useState(sessionData.seatsAlloted);
  const [regStartDate, setRegStartDate] = useState(sessionData.registrationStartDate);
  const [regEndDate, setRegEndDate] = useState(sessionData.registrationEndDate);
  
  // Fix: Use the hosts array from API response
  const selectedHosts = sessionData.hosts || [];
  // --- External Host State ---
  const [hasExternalHost, setHasExternalHost] = useState(selectedHosts.some(h => h.isExternal));
  const [externalHost, setExternalHost] = useState("");
  const [externalHostEmail, setExternalHostEmail] = useState("");
  const [externalHosts, setExternalHosts] = useState(selectedHosts.filter(h => h.isExternal).map(h => ({ hostName: h.hostName, hostEmail: h.hostEmail })));
  const [displayValue, setDisplayValue] = useState("");
  const [forceUpdate, setForceUpdate] = useState(0);
  const [selectedUsers, setSelectedUsers] = useState([]);
  // Always initialize as array to avoid undefined issues
  const selectedSessionSkills = sessionData.targetedSkill.split(',');
  const [selectedSkills, setSelectedSkills] = useState();
  const [otherSkills, setOtherSkills] = useState();
  const [selectedUserIds, setSelectedUserIds] = useState("");
  const [selectedSkillsIds, setSelectedSkillsIds] = useState("");
  const [isFeedbackEmailEnabled, setIsFeedbackEmailEnabled] = useState(
    sessionData.isEmailFeedBack !== undefined && sessionData.isEmailFeedBack !== null
      ? sessionData.isEmailFeedBack 
      : false
  );
  


  const dispatch = useDispatch();


  useEffect(() => {
    if (selectedHosts.length > 0) {
      // Separate internal and external hosts
      const internalHosts = selectedHosts.filter(h => !h.isExternal);
      const allUsersList = (allUserDetails && allUserDetails.data) ? allUserDetails.data : [];
      const hostsAsUsers = internalHosts.map(host => {
        const hostId = host.employeeId || host.hostId;
        const matchedUser = allUsersList.find(u => String(u.id) === String(hostId));
        if (matchedUser) return matchedUser;
        return {
          id: hostId,
          firstName: (host.hostName || '').split(' ')[0] || '',
          lastName: (host.hostName || '').split(' ').slice(1).join(' ') || '',
          email: host.hostEmail || '',
          fullName: host.hostName || ''
        };
      });
      setSelectedUsers(hostsAsUsers.length ? hostsAsUsers : []);
      setSelectedUserIds(hostsAsUsers.length ? hostsAsUsers.map(user => user.id).join(',') : '');
      // Set external hosts state only from external hosts
      setExternalHosts(selectedHosts.filter(h => h.isExternal).map(h => ({ hostName: h.hostName, hostEmail: h.hostEmail })));
      setHasExternalHost(selectedHosts.some(h => h.isExternal));
    } else {
      setSelectedUsers([]);
      setSelectedUserIds("");
    }
    if (allUserDetails) {
      setUserMembers(allUserDetails);
    }
  }, [allUserDetails, selectedHosts]);
  useEffect(() => {
    if (selectedUsers) {
      setSelectedUserIds(selectedUsers.map(user => user.id).join(','));
    }
  }, [selectedUsers]);

  useEffect(() => {
    if (listItems && listItems.Skills && listItems.Skills.length) {
      setUserSkills(listItems.Skills);
    }
  }, [listItems]);

  useEffect(() => {
    if (userSkills &&  userSkills.length) {
      let filteredUserSkills = userSkills.filter(skill=>selectedSessionSkills.includes(skill.longCodeValue));
      const restSkills = selectedSessionSkills.filter(skill =>!userSkills.some(userSkill => userSkill.longCodeValue === skill));

      if(restSkills[0]&&restSkills[0].length){
        const othersSkill = userSkills.find(skill => skill.longCodeValue === "Others");
        filteredUserSkills.push(othersSkill);
      }
      setSelectedSkills(filteredUserSkills)
      setOtherSkills(restSkills.join(', '))
      
    }
  }, [userSkills]);

  useEffect(() => {
    if (selectedSkills && selectedSkills.length) {
      setSelectedSkillsIds(selectedSkills.map(skill=> skill.longCodeValue).join(','))
    }
  }, [selectedSkills]);

  const handleClose = () => {
    setSelectedUserIds("")
    props.onResponse(true);
  }

  const handleUserChange = (event) => {
    const {
      target: { value },
    } = event;
    
    // Check if "external" is being selected or deselected
    if (value.includes("external")) {
      // External facilitator is being selected
      setHasExternalHost(true);
      // Keep only user id values, filter out "external"
      const actualIds = value.filter(v => v !== "external").map(v => String(v));
      const allUsersList = (userMembers && userMembers.data) ? userMembers.data : [];
      const actualUsers = allUsersList.filter(u => actualIds.includes(String(u.id)));
      setSelectedUsers(actualUsers);
      setSelectedUserIds(actualIds.join(","));
    } else {
      // External facilitator is being deselected or not selected
      if (hasExternalHost && !value.includes("external")) {
        setHasExternalHost(false);
        setExternalHost("");
        setExternalHosts([]); // Reset external hosts array
      }
      const idsOnly = value.map(v => String(v));
      const allUsersList = (userMembers && userMembers.data) ? userMembers.data : [];
      const users = allUsersList.filter(u => idsOnly.includes(String(u.id)));
      setSelectedUsers(users);
      setSelectedUserIds(idsOnly.join(","));
    }
  };
  const handleUserChangeSkills = (event) => {
    const {
      target: { value },
    } = event;
    if (value.findIndex((val) => val === "Select All") > -1) {
      if (selectAll) {
        setSelectedSkills([]);
        setSelectedSkillsIds("");
      } else {
        setSelectedSkills(listItems.Skills);
        let ids = listItems.Skills?.map((user) => {
          return user.longCodeValue;
        });
        setSelectedSkillsIds(ids.join(","));
      }
      setSelectAll(!selectAll);
    } else {
      setSelectedSkills(value);
      let ids = value.map((user) => {
        return user.longCodeValue;
      });
      setSelectedSkillsIds(ids.join(","));
    }
  };
  const getUsersNames = () => {
    console.log("getUsersNames called - hasExternalHost:", hasExternalHost, "externalHost:", externalHost);
    console.log("selectedUsers:", selectedUsers);
    console.log("externalHosts:", externalHosts);
    
    let selectedNames = "";
    
    // Add internal hosts with email addresses
    if (selectedUsers && selectedUsers.length) {
      for (let i = 0; i < selectedUsers.length; i++) {
        const userName = selectedUsers[i].fullName || 
                        (selectedUsers[i].firstName + " " + selectedUsers[i].lastName);
        const emailText = selectedUsers[i].email ? ` (${selectedUsers[i].email})` : '';
        selectedNames += userName + emailText;
        if (i !== selectedUsers.length - 1) selectedNames += ", ";
      }
    }
    
    // Add external hosts with optional email addresses
    if (externalHosts && externalHosts.length) {
      if (selectedNames) selectedNames += ", ";
      const externalNames = externalHosts.map(host => {
        if (typeof host === 'string') {
          return host; // Legacy format support
        }
        return host.hostName + (host.hostEmail ? ` (${host.hostEmail})` : '');
      });
      selectedNames += externalNames.join(", ");
    }
    
    // Show current typing external host name with optional email (real-time display)
    if (hasExternalHost && externalHost.trim()) {
      if (selectedNames) selectedNames += ", ";
      selectedNames += externalHost.trim();
      if (externalHostEmail.trim()) {
        selectedNames += ` (${externalHostEmail.trim()})`;
      }
    }
    
    console.log("Final selectedNames:", selectedNames);
    return selectedNames;
  };
  const getSkillsName = () => {
    let selectedSkillsName = "";
    if (selectedSkills && selectedSkills.length) {
      for (let i = 0; i < selectedSkills.length; i++) {
        selectedSkillsName += `${selectedSkills[i].longCodeValue}`;
        if (i !== selectedSkills.length - 1) selectedSkillsName += ", ";
      }
    }
    return selectedSkillsName;
  };

  return (
    <div style={{ maxWidth: "110%", width: "100%", padding: "1rem", boxSizing: "border-box" }}>

      <div className="heading" style={{ marginBottom: "3rem" }}>
        Edit Session
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem", marginBottom: "2rem" }}>
        <div style={{ flex: "1", minWidth: "300px" }}>
          <label style={{ marginBottom: "1.2rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Session Name *</label>
          <TextField
            // label="Enter Name"
            required
            value={sessionName}
            onChange={(e) => setSessionName(e.target.value)}
            variant="outlined"
            InputProps={{ style: { height: '4rem' } }}
            style={{ width: "100%" }}
          />
        </div>

        <div style={{ flex: "1", minWidth: "300px" }}>
          <label style={{ marginBottom: "1.2rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Session Host(s) *</label>
          <FormControl sx={{ width: "100%" }}>
            <InputLabel required>
              Select Host(s)
            </InputLabel>
            <Select
              multiple
              value={selectedUserIds ? selectedUserIds.split(',').filter(Boolean) : []}
              onChange={handleUserChange}
              input={<OutlinedInput label="Select Host(s)" />}
              renderValue={() => {
                return getUsersNames(); // Use the function that handles both internal and external hosts
              }}
              displayEmpty
              style={{ height: "4rem", fontSize: "1.4rem" }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 400,
                  },
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              }}
            >

              {allUserDetails && allUserDetails.data && (
                <ListSubheader className="subheader">
                  <TextField
                    placeholder="Search Here..."
                    className="subheader-field"
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                    autoFocus={true}
                    onChange={(e) => {
                      setUserMembers({
                        ...allUserDetails,
                        data: allUserDetails.data.filter(
                          (i) =>
                            i.firstName
                              ?.toLowerCase()
                              .includes(e.target.value.toLowerCase()) ||
                            i.lastName
                              ?.toLowerCase()
                              .includes(e.target.value.toLowerCase()) ||
                            i.email
                              ?.toLowerCase()
                              .includes(e.target.value.toLowerCase())
                        ),
                      });
                    }}
                  />
                  {hasExternalHost && (
                    <div style={{ paddingTop: "1rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
                      <div style={{ display: "flex", gap: "0.5rem" }}>
                        <TextField
                          placeholder="Enter External Facilitator Name"
                          required
                          value={externalHost}
                          onKeyDown={(e) => {
                            e.stopPropagation();
                            if (e.key === 'Enter' && externalHost.trim()) {
                              setExternalHost(externalHost.trim());
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <span style={{ color: 'red' }}>*</span>
                            ),
                          }}
                          onChange={(e) => {
                            setExternalHost(e.target.value);
                          }}
                          sx={{ width: "20rem" }}
                        />
                        <TextField
                          placeholder="Enter Email (Optional)"
                          value={externalHostEmail}
                          onKeyDown={(e) => {
                            e.stopPropagation();
                          }}
                          onChange={(e) => setExternalHostEmail(e.target.value)}
                          sx={{ width: "20rem" }}
                        />
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            if (externalHost.trim()) {
                              const newExternalHost = {
                                hostName: externalHost.trim(),
                                hostEmail: externalHostEmail.trim() || null
                              };
                              setExternalHosts(prev => [...prev, newExternalHost]);
                              setExternalHost('');
                              setExternalHostEmail('');
                              setForceUpdate(prev => prev + 1);
                            }
                          }}
                          disabled={!externalHost.trim()}
                          sx={{ height: "3.5rem", minWidth: "6rem" }}
                        >
                          Add
                        </Button>
                      </div>
                      {externalHosts.length > 0 && (
                        <div style={{
                          background: "#f5f5f5",
                          padding: "1rem",
                          borderRadius: "4px",
                          maxHeight: "10rem",
                          overflowY: "auto"
                        }}>
                          <div style={{ fontSize: "0.9rem", fontWeight: "bold", marginBottom: "0.5rem" }}>
                            Added External Facilitators:
                          </div>
                          {externalHosts.map((host, index) => (
                            <div key={index} style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "0.3rem 0",
                              borderBottom: index < externalHosts.length - 1 ? "1px solid #ddd" : "none"
                            }}>
                              <span>
                                {typeof host === 'string' ? host :
                                  `${host.hostName}${host.hostEmail ? ` (${host.hostEmail})` : ''}`
                                }
                              </span>
                              <Button
                                size="small"
                                color="error"
                                onClick={() => {
                                  setExternalHosts(prev => prev.filter((_, i) => i !== index));
                                  setForceUpdate(prev => prev + 1);
                                }}
                                sx={{ minWidth: "auto", padding: "0.2rem" }}
                              >
                                ✕
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </ListSubheader>
              )}
              
              <MenuItem value="external">
                <Checkbox
                  checked={hasExternalHost}
                />
                <ListItemText primary="Others (External Facilitator)" />
              </MenuItem>
              {userMembers &&
                userMembers.data.map((user) => {
                  // Defensive: ensure selectedUsers is always an array
                  const selectedIds = selectedUserIds ? selectedUserIds.split(',') : [];
                  const isChecked = selectedIds.includes(String(user.id));
                  return (
                    <MenuItem
                      key={user.id}
                      value={user.id}
                      className="no-left-margin"
                    >
                      <Checkbox
                        checked={isChecked}
                      />
                      <ListItemText
                        primary={
                          getFullName(user.firstName, user.lastName) +
                          " (" +
                          user.email +
                          ")"
                        }
                      />
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
              <div
                disabled={selectedUserIds === ""}
                style={{
                  textAlign: "right",
                  cursor: "pointer",
                  height: "2rem",
                }}
              >
                <Link
                  onClick={() => {
                    setSelectedUsers([]);
                    setSelectedUserIds("");
                    setSelectAll(false);
                  }}
                  style={{ color: "#1773bc", paddingRight: "1rem" }}
                >
                  Clear Selection
                </Link>
              </div>

      </div>

      <div style={{ width: "100%", marginBottom: "2rem" }}>
        <label style={{ marginBottom: "0.5rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Skill(s) Targeted *</label>
        <FormControl sx={{ width: '100%' }}>
          <InputLabel required ></InputLabel>
          <Select
            multiple
            value={selectedSkills?selectedSkills:[]}
            onChange={handleUserChangeSkills}
            input={<OutlinedInput label="Select Skill(s)" />}
            renderValue={getSkillsName}
            style={{ height: "4rem", fontSize:"1.4rem" }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 400,
                },
              },
            }}
            >
              {listItems && (
                <ListSubheader className="subheader">
                  <TextField
                    placeholder="Search Here..."
                    className="subheader-field"
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                    autoFocus={true}
                    onChange={(e) => {
                      setUserSkills(
                        listItems.Skills.filter((i) =>
                          i.longCodeValue
                            ?.toLowerCase()
                            .includes(e.target.value.toLowerCase())
                        )
                      );
                    }}
                  />
                  {selectedSkillsIds&&selectedSkillsIds.includes("Others") ? (
                    <TextField
                      placeholder="Enter Other Skills"
                      required
                      value={otherSkills}
                      onKeyDown={(e) => {
                        e.stopPropagation();
                      }}
                      InputProps={{
                        endAdornment: (
                          <span style={{ color: 'red' }}>*</span>
                        ),
                      }}
                      autoFocus={true}
                      onChange={(e) => setOtherSkills(e.target.value)}
                      sx={{paddingTop:"1rem", width: "100%"}}
                    />
                  ):''}
                </ListSubheader>
              )}
              
              <div
                disabled={selectedSkillsIds===""}
                style={{
                  textAlign: "right",
                  cursor: "pointer",
                  height: "2rem",
                }}
              >
                <Link
                  onClick={() => {
                    setSelectedSkills([]);
                    setSelectedSkillsIds("");
                    setSelectAll(false);
                  }}
                  style={{ color: "#1773bc", paddingRight: "1rem" }}
                >
                  Clear Selection
                </Link>
              </div>

              {userSkills && userSkills.length &&
                userSkills?.map((user) => (
                  <MenuItem
                    key={user.id}
                    value={user}
                    className="no-left-margin"
                  >
                    <Checkbox
                      checked={
                        selectedSkills&&selectedSkills.findIndex(
                          (person) => person.id === user.id
                        ) > -1
                      }
                    />
                    <ListItemText primary={user.longCodeValue} />
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem", marginBottom: "2rem" }}>
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label style={{ marginBottom: "1.7rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Session Date *</label>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              sx={{
                "& label": {
                  lineHeight: "0.8rem",
                  display: "flex",
                  alignItems: "center",
                },
              }}
            >
              <DatePicker
                className="custom-datepicker"
                required
                label={
                  <div>
                    Select Date{" "}
                    <span style={{ color: "red" }}>*</span>
                  </div>
                }
                value={sessionDate}
                onChange={(newValue) => {
                  setSessionDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    InputProps={{ style: { height: '7rem' } }}
                    style={{
                      width: "100%",
                    }}
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label style={{ marginBottom: "1.7rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Total Seats *</label>
            <TextField
              label="Enter Number of Seats"
              required
              value={totalSeats}
              onChange={(e) => setTotalSeats(e.target.value)}
              variant="outlined"
              InputProps={{ style: { height: '4rem' } }}
              style={{ width: "100%" }}
            />
          </div>

          <div style={{ flex: "1", minWidth: "200px" }}>
            <label style={{ marginBottom: "1.7rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Status *</label>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel required>Select Status</InputLabel>
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                label="Select Status"
                style={{ height: "4rem", fontSize:"1.4rem" }}
              >
                {STATUS_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem", marginBottom: "2rem" }}>
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label style={{ marginBottom: "0.5rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>
              Start Time *
            </label>
            <TextField
              type="time"
              required
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              InputProps={{ style: { height: '4rem' } }}
              style={{ width: "100%" }}
            />
          </div>
          
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label style={{ marginBottom: "0.5rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>
              End Time *
            </label>
            <TextField
              type="time"
              required
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              InputProps={{ style: { height: '4rem' } }}
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem"}}>
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label style={{ marginBottom: "1.7rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Registration Start Date *</label>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              sx={{
                "& label": {
                  lineHeight: "0.8rem",
                  display: "flex",
                  alignItems: "center",
                },
              }}
            >
              <DatePicker
                className="custom-datepicker"
                required
                label={
                  <div>
                    Select Date{" "}
                    <span style={{ color: "red" }}>*</span>
                  </div>
                }
                value={
                  regStartDate
                }
                onChange={(newValue) => {
                  setRegStartDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    InputProps={{ style: { height: '4rem' } }}
                    style={{
                      width: "100%",
                    }}
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label style={{ marginBottom: "1.7rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Registration End Date *</label>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              sx={{
                "& label": {
                  lineHeight: "0.8rem",
                  display: "flex",
                  alignItems: "center",
                },
              }}
            >
              <DatePicker
                className="custom-datepicker"
                required
                label={
                  <div>
                    Select Date{" "}
                    <span style={{ color: "red" }}>*</span>
                  </div>
                }
                value={
                  regEndDate
                }
                onChange={(newValue) => {
                  setRegEndDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    InputProps={{ style: { height: '4rem' } }}
                    style={{
                      width: "100%",
                    }}
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
        </div>

        <div style={{ width: "100%", marginBottom: "0rem" }}>
          <label style={{ marginBottom: "0.5rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>
            Description *
          </label>
          <TextField
            placeholder="Description"
            required
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            inputProps={{
              style: {
                minHeight: "0.5rem",
                fontSize: "1.6rem"
              },
              className: "sessionDescription",
            }}
            multiline
            rows={2}
            fullWidth
          />
        </div>

        <div style={{ width: "100%", marginBottom: "2rem" }}>
          <FormControlLabel
            control={
              <Switch
                checked={isFeedbackEmailEnabled}
                onChange={(e) => setIsFeedbackEmailEnabled(e.target.checked)}
                color="primary"
              />
            }
            label={
              <span style={{ fontFamily: "Montserrat", fontSize: "1.2rem", color: "#333" }}>
                Enable Feedback Email Notifications
              </span>
            }
            style={{ marginTop: "1rem" }}
          />
        </div>

        <div style={{ display: "flex", paddingTop: "0rem", justifyContent: "flex-end", gap: "1rem" }}>
          <Button
            onClick={() => {
              if(selectedSkillsIds.includes("Others")) {
                if(!otherSkills){
                  toast.error("Please Fill Other Skills",toastOptions);
                  return
                }
              }

              // Add description validation before creating data object
              if (!description.trim()) {
                toast.error("Please Fill Description", toastOptions);
                return;
              }

              let data = {
                sessionId: props.sessionId,
                updateData: {
                  sessionName: sessionName,
                  targetedSkill: selectedSkillsIds.replace(/Others/, otherSkills),
                  startTime: startTime,
                  endTime: endTime,
                  sessionDate: sessionDate && dayjs(sessionDate).format("DD MMM YYYY"),
                  description: description,
                  SaveOrPublish: status === "Draft" ? 0 : 1,
                  seatsAlloted: totalSeats,
                  registrationStartDate: regStartDate && dayjs(regStartDate).format("DD MMM YYYY"),
                  registrationEndDate: regEndDate && dayjs(regEndDate).format("DD MMM YYYY"),
                  status: status,
                  isFeedbackEmailEnabled: isFeedbackEmailEnabled,
                  // hosts: comma-separated string of internal host IDs
                  hosts: selectedUserIds,
                  // hostsList: array of all hosts (internal and external)
                  hostsList: [
                    // Internal hosts
                    ...(selectedUsers && selectedUsers.length
                      ? selectedUsers.map(u => ({
                          externalHostId: null,
                          employeeId: u.id ? u.id.toString() : null,
                          hostName: u.fullName || (u.firstName + " " + u.lastName),
                          externalHostEmail: null,
                          isExternal: false,
                          externalHostName: null
                        }))
                      : []),
                    // External hosts
                    ...(externalHosts && externalHosts.length
                      ? externalHosts.map((host, idx) => ({
                          externalHostId: `EXT_GUEST_${Date.now()}${idx}`,
                          employeeId: null,
                          hostName: host.hostName,
                          externalHostEmail: host.hostEmail || null,
                          isExternal: true,
                          externalHostName: host.hostName
                        }))
                      : []),
                    // If user is typing a new external host but hasn't added it yet
                    ...(hasExternalHost && externalHost.trim()
                      ? [{
                          externalHostId: `EXT_GUEST_${Date.now()}_TYPED`,
                          employeeId: null,
                          hostName: externalHost.trim(),
                          externalHostEmail: externalHostEmail.trim() || null,
                          isExternal: true,
                          externalHostName: externalHost.trim()
                        }]
                      : [])
                  ]
                }
              }

              // Validation for all required fields (allow empty hosts string if only external hosts)
              for (const key in data.updateData) {
                if (key != "SaveOrPublish" && key !== "isFeedbackEmailEnabled" && key !== "hosts" && !data.updateData[key]) {
                  let errMsg = key.replace(/([A-Z])/g, ' $1')
                  errMsg = errMsg.charAt(0).toUpperCase() + errMsg.slice(1)
                  errMsg = "Please Fill " + errMsg
                  toast.error(errMsg, toastOptions);                  
                  return
                }
              }

              // Ensure at least one host overall (internal or external)
              const totalHostsCount = (data.updateData.hostsList && data.updateData.hostsList.length) || 0;
              if (totalHostsCount === 0) {
                toast.error("Please select at least one host", toastOptions);
                return;
              }

              dispatch(updateSession(data));
            }}
            type="submit" 
            variant="contained" 
            color="primary" 
            style={{ height: "3rem", minWidth: "150px" }}
          >
            Update Session
          </Button>
          
          <Button 
            onClick={() => {
              setSessionName('')
              setSelectedUsers([])
              setSelectedUserIds("")
              setSelectedSkills([])
              setSelectedSkillsIds("")
              setSessionDate(new Date())
              setRegStartDate(new Date())
              setRegEndDate(new Date())
              setTotalSeats(25)
              setDescription('')
              setStartTime('');
              setEndTime('');
              handleClose()
            }}
            variant="contained" 
            style={{ height: "3rem", minWidth: "100px", background:"lightgray", color:"black" }}
          >
            Close
          </Button>
        </div>

      </div>
      </div>
    );
  };